// extracted by mini-css-extract-plugin
export default {"modalContainer":"FullQuizCreatorModal_modalContainer__0pybO","outer":"FullQuizCreatorModal_outer__mgiec","inner":"FullQuizCreatorModal_inner__N1Gaa"};